import { TherapistProperties } from '../../../../redux/API/ClientAPIHelpers/clientProperties';
import { AuthorizationType } from '../models/AuthorizationType.enum';

export const getBadgeProps = (
	authType: TherapistProperties['authorizationType'],
	roleName: string,
): { label: string; type: 'solidSuccess' | 'warning' } => {
	if (authType?.name === AuthorizationType.LICENSED) {
		return { label: AuthorizationType.LICENSED, type: 'solidSuccess' };
	}

	if (authType?.name === AuthorizationType.LIMITED_PERMIT) {
		return { label: AuthorizationType.LIMITED_PERMIT, type: 'warning' };
	}

	if (!authType && roleName === AuthorizationType.LICENSED) {
		return { label: AuthorizationType.LICENSED, type: 'solidSuccess' };
	}

	return {
		label: authType?.name || AuthorizationType.LICENSED,
		type: 'solidSuccess',
	};
};
